module.exports = __webpack_public_path__ + "media/images/coupon/img-coupon-name-44ba3888bbb5f253da2719454a5d4cd1.png";